"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsPackagingStatus = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/packaging-status.scss");
/**
 * Renders the stage indicator for a single use case in the progress table.
 *
 * @param {WsPackagingStatusProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsPackagingStatus = function (props) {
    var stageValue = props.useCase.fields.stage;
    var parsedStage = typeof stageValue === "number" ? stageValue : Number(stageValue);
    var currentStage = Number.isFinite(parsedStage) ? parsedStage : 1;
    if (currentStage === props.status) {
        return (react_1.default.createElement(office_ui_fabric_react_1.Icon, { className: "ws-packaging-status ws-packaging-in-progress", iconName: "Clock" }));
    }
    if (currentStage > props.status) {
        return (react_1.default.createElement(office_ui_fabric_react_1.Icon, { className: "ws-packaging-status ws-packaging-complete", iconName: "CheckMark" }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.WsPackagingStatus = WsPackagingStatus;
